export default {
    loadSearchResult: (state, payload, term) => {
        state.searchTerm = term;
        state.searchResult = payload;
        state.technicalError = null;
    },
    setError: (state, payload) => {
        state.technicalError  = payload;
    }
};